/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import {INodeProps, Module, Node} from "@msdyn365-commerce-modules/utilities";
import * as React from "react";

import {
  ISearchCategoryViewProps,
  ISearchFormViewProps,
} from "@msdyn365-commerce-modules/search/";

const SearchView: React.FC<any> = (props) => {
  const {
    Search,
    AutoSuggestAriaLabel,
    AutoSuggestAriaLabelText,
    searchText,
    AutoSuggest,
    KeywordSuggest,
    ProductSuggest,
    CategorySuggest,
    UlKeyword,
    UlProduct,
    UlCategory,
    form,
    autosuggestCategory,
    autosuggestKeyword,
    autosuggestProduct,
    SearchForm,
    FormWrapper,
    label,
    isLoadingAutoSuggest,
    isLoadingNode,
  } = props;

  //END

  return (
    <Module {...Search}>
      {label}
      {_renderForm(form as ISearchFormViewProps, SearchForm, FormWrapper)}
      <Node {...AutoSuggest}>
        {searchText && searchText.length > 0 ? (
          <Node {...AutoSuggestAriaLabel}>{AutoSuggestAriaLabelText}</Node>
        ) : (
          ""
        )}

        {_renderKeywordSuggestions(
          KeywordSuggest,
          UlKeyword,
          autosuggestKeyword?.text,
          isLoadingAutoSuggest,
          isLoadingNode,
        )}
        {_renderProductSuggestions(
          ProductSuggest,
          UlProduct,
          autosuggestProduct?.items,
          autosuggestProduct?.title,
          isLoadingAutoSuggest,
          isLoadingNode,
        )}
        {_renderCategorySuggestions(
          CategorySuggest,
          UlCategory,
          autosuggestCategory,
          isLoadingAutoSuggest,
          isLoadingNode,
        )}
      </Node>
    </Module>
  );
};

const _renderForm = (
  form: ISearchFormViewProps,
  SearchForm: INodeProps,
  FormWrapper: INodeProps,
) => {
  return (
    <Node {...SearchForm}>
      <Node {...FormWrapper}>
        {form.input}
        {form.cancelBtn}
        {form.submitBtn}
      </Node>
    </Node>
  );
};

const _renderKeywordSuggestions = (
  KeywordSuggest: INodeProps,
  UlKeyword: INodeProps,
  keywordSuggestions?: any,
  isLoadingAutoSuggest?: boolean,
  isLoadingNode?: React.ReactNode,
) => {
  return (
    keywordSuggestions && (
      <Node {...KeywordSuggest}>
        <Node {...UlKeyword}>
          {isLoadingAutoSuggest && isLoadingNode}
          {!isLoadingAutoSuggest &&
            keywordSuggestions?.map((text: any) => {
              return text;
            })}
        </Node>
      </Node>
    )
  );
};

const _renderProductSuggestions = (
  ProductSuggest: INodeProps,
  UlProduct: INodeProps,
  productSuggestions?: any,
  title?: any,
  isLoadingAutoSuggest?: boolean,
  isLoadingNode?: React.ReactNode,
) => {
  return (
    productSuggestions && (
      <Node {...ProductSuggest}>
        <Node {...UlProduct}>
          {title}
          {isLoadingAutoSuggest && isLoadingNode}

          {!isLoadingAutoSuggest &&
            productSuggestions?.map((item: any, index: any) => {
              return (
                <Node {...item.LiProduct} key={item.id || index}>
                  <Node {...item.AProduct}>
                    {item.thumbnail}
                    {item.text}
                    {/* {item.price} */}
                  </Node>
                </Node>
              );
            })}
        </Node>
      </Node>
    )
  );
};

const _renderCategorySuggestions = (
  CategorySuggest: INodeProps,
  UlCategory: INodeProps,
  categorySuggestions?: ISearchCategoryViewProps,
  isLoadingAutoSuggest?: boolean,
  isLoadingNode?: React.ReactNode,
) => {
  return (
    categorySuggestions && (
      <Node {...CategorySuggest}>
        <Node {...UlCategory}>
          {categorySuggestions.title}
          {isLoadingAutoSuggest && isLoadingNode}

          {!isLoadingAutoSuggest &&
            categorySuggestions.text.map((text) => {
              return text;
            })}
        </Node>
      </Node>
    )
  );
};

export default SearchView;
